module.exports = __webpack_public_path__ + "static/media/le-trong-dao.357faf54.png";